export const evaluateLink = '/see-a-demo/evaluate'

export const bookingLink = '/qualification/contact-sales'
export const demoFallbackLink = '/view-demo'
export const thanksLink = '/thanks-for-booking'
